import { Loader2Icon } from "lucide-react"

import { cn } from "../../lib/utils"

// Decorative by default: Spinner is meant to sit next to a visible text label
// (e.g. BusyButton's busyLabel) that already carries the "loading" meaning —
// a spoken "Loading" on top of that would double-announce. Callers that use
// it standalone, with no adjacent label, should override aria-hidden/role.
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      aria-hidden="true"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
